import React, { FC, useMemo } from 'react';
import { Carousel, Col, Row, Tooltip } from 'antd';
import stylesModule from './CompanyLogoList.module.less';
import CompanyImage from '../../public/company.png';
import { HomePageRecruiter } from '../../page-components/home/HomePage';
import Image from 'next/image';
import Link from 'antd/lib/typography/Link';
import Utils from '../../utils/Utils';

const styles: any = stylesModule;

type Props = {
  logos: HomePageRecruiter[];
  logosperslide: number;
  md?: number;
  lg?: number;
  sm?: number;
  xs?: number;
  xl?: number;
};

export const CompanyLogoList: FC<Props> = (props) => {
  const { lg, md, sm, xs, xl, logosperslide } = props;
  const logoAvailableCompanies: HomePageRecruiter[] = props.logos;

  const arr1 = useMemo(
    () => logoAvailableCompanies.slice(0, logosperslide),
    [logoAvailableCompanies, logosperslide],
  );
  const arr2 = useMemo(
    () => logoAvailableCompanies.slice(logosperslide, logosperslide * 2),
    [logoAvailableCompanies, logosperslide],
  );
  const arr3 = useMemo(() => {
    if (logoAvailableCompanies.length >= logosperslide * 3) {
      return logoAvailableCompanies.slice(logosperslide * 2, logosperslide * 3);
    } else {
      return [];
    }
  }, [logoAvailableCompanies, logosperslide]);

  //   const arr1 = useMemo(() => logoAvailableCompanies.slice(0, 9), [logoAvailableCompanies]);
  // const arr2 = useMemo(() => logoAvailableCompanies.slice(9, 18), [logoAvailableCompanies]);
  // const arr3 = useMemo(() => logoAvailableCompanies.slice(18, 27), [logoAvailableCompanies]);

  return (
    <>
      <div className={styles.main}>
        <Row gutter={[36, 32]} className={styles.row}>
          {logoAvailableCompanies.map((item) => {
            return (
              <Col
                lg={lg ?? 2.66}
                md={md ?? undefined}
                sm={sm ?? undefined}
                xs={xs ?? undefined}
                xl={xl ?? undefined}
                key={item.id}>
                <Tooltip title={item.name}>
                  <Link href={`/recruiters/${Utils.normalizeURIComponent(item.name)}/${item.id}`}>
                    <div className={styles.container}>
                      {item.logo ? (
                        <Image
                          width={50}
                          height={50}
                          alt={item.name}
                          src={item.logo}
                          unoptimized={true}
                          style={{ width: '100%', height: '100%' }}
                        />
                      ) : (
                        <Image src={CompanyImage} width={76} alt={item.name} />
                      )}
                    </div>
                  </Link>
                </Tooltip>
              </Col>
            );
          })}
        </Row>
        {/*<div className={styles.gridContainer}>*/}
        {/*  {logos?.map((item) => {*/}
        {/*    return (*/}
        {/*      <div key={item.id}>*/}
        {/*        <Tooltip title={item.name}>*/}
        {/*          <Link*/}
        {/*            href={`recruiters/${item.id}/${Utils.encodeURIComponent(item.name)}`}>*/}
        {/*            <a>*/}
        {/*              <div className={styles.container}>*/}
        {/*                {item.logo ? (*/}
        {/*                  <img*/}
        {/*                    alt={item.name}*/}
        {/*                    src={item.logo}*/}
        {/*                    style={{ width: '100%', height: '100%' }}*/}
        {/*                  />*/}
        {/*                ) : (*/}
        {/*                  <Image src={CompanyImage} alt={item.name} />*/}
        {/*                )}*/}
        {/*              </div>*/}
        {/*            </a>*/}
        {/*          </Link>*/}
        {/*        </Tooltip>*/}
        {/*      </div>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</div>*/}
      </div>
      <div className={styles.mainMobile}>
        <Carousel dots>
          {arr1?.length > 0 && (
            <div>
              <Row>
                {arr1?.map((item, i) => {
                  return (
                    <Col key={i} sm={8} md={8} xs={8}>
                      <Tooltip title={item.name}>
                        <Link
                          href={`/recruiters/${Utils.normalizeURIComponent(item.name)}/${item.id}`}>
                          <div className={styles.container}>
                            {item.logo ? (
                              <Image
                                width={50}
                                height={50}
                                alt={item.name}
                                src={item.logo}
                                unoptimized={true}
                                style={{ width: '100%', height: '100%' }}
                              />
                            ) : (
                              <Image src={CompanyImage} width={76} alt={item.name} />
                            )}
                          </div>
                        </Link>
                      </Tooltip>
                    </Col>
                  );
                })}
              </Row>
            </div>
          )}
          {arr2?.length > 0 && (
            <div>
              <Row>
                {arr2?.map((item, i) => {
                  return (
                    <Col key={i} sm={8} md={8} xs={8}>
                      <Tooltip title={item.name}>
                        <Link
                          href={`/recruiters/${Utils.normalizeURIComponent(item.name)}/${item.id}`}>
                          <div className={styles.container}>
                            {item.logo ? (
                              <Image
                                width={50}
                                height={50}
                                alt={item.name}
                                src={item.logo}
                                unoptimized={true}
                                style={{ width: '100%', height: '100%' }}
                              />
                            ) : (
                              <Image src={CompanyImage} width={76} alt={item.name} />
                            )}
                          </div>
                        </Link>
                      </Tooltip>
                    </Col>
                  );
                })}
              </Row>
            </div>
          )}

          {arr3?.length > 0 && (
            <div>
              <Row>
                {arr3?.map((item, i) => {
                  return (
                    <Col key={i} sm={8} md={8} xs={8}>
                      <Tooltip title={item.name}>
                        <Link
                          href={`/recruiters/${Utils.normalizeURIComponent(item.name)}/${item.id}`}>
                          <div className={styles.container}>
                            {item.logo ? (
                              <Image
                                width={50}
                                height={50}
                                alt={item.name}
                                src={item.logo}
                                unoptimized={true}
                                style={{ width: '100%', height: '100%' }}
                              />
                            ) : (
                              <Image src={CompanyImage} width={76} alt={item.name} />
                            )}
                          </div>
                        </Link>
                      </Tooltip>
                    </Col>
                  );
                })}
              </Row>
            </div>
          )}
        </Carousel>
      </div>
    </>
  );
};
